import React from 'react';
import axios from 'axios';
import { toast } from 'bulma-toast';
import server from '../../../../utilities/server';

const CategoryImage = ({ modal, setModal, refetch, category }) => {

  const [image, setImage] = React.useState(null);
  const [imageData, setImageData] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  const _selectImage = (image) => {
    setImage(image.target.files[0]);
  }
  const _deselectImage = () => {
    setImage(null);
  }
  const ShowImage = () => {
    if (!imageData) { return null; }
    return (
      <div id='theme' className='has-text-centered p-3'>
        <a className='delete' aria-label='close' onClick={_deselectImage}></a>
        <img src={imageData} style={{ maxWidth: 150, maxHeight: 150, }} /><br />
        {
          category.image && typeof category.image === 'string' ? <a className='button is-danger' onClick={_deleteImage} style={loading ? { PointerEvent: 'none' } : null}>حذف الصورة</a> : null
        }
      </div>
    )
  }

  const _deleteImage = async () => {
    setLoading(true);
    try {
      await axios.delete(`http://localhost:3003/admin/media/category-image/${category.id}`, { params: { name: category.image, } });
      toast({ type: 'is-success', position: 'center', message: 'تم حذف الصورة بنجاح', });
      setImageData(null);
      setLoading(false);
    } catch(_) {
      setLoading(false);
      toast({ type: 'is-danger', position: 'center', message: 'خطأ أثناء حذف الصورة', });
    }
  }

  const _getImage = async () => {
    if (category.image) {
      const getImage = await axios.get('http://localhost:3003/admin/media/category-image', { params: { name: category.image, }, responseType: 'blob', });
      setImageData(URL.createObjectURL(getImage.data));
      } else {
        setImageData(null);
      }
  }

  const _submit = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append('theme', image);
    formData.append('resize', true);
    server({
      method: 'put',
      path: `categories/image/${category.id}`,
      data: formData,
    }).then((updateCategory) => {
      console.log(updateCategory)
      toast({ type: 'is-success', position: 'center', message: 'تم رفع الصورة بنجاح' });
      refetch();
      setModal({ id: 0, name: null });
      setImage(null);
      setLoading(false);
    }).catch((_) => {
      console.log(_.response)
      toast({ type: 'is-danger', position: 'center', message: 'خطأ أثناء رفع الصورة' });
      setModal({ id: 0, name: null });
      setLoading(false);
    });
  }

  React.useEffect(() => {
    _getImage();
    if (image && typeof image === 'object') {
      let reader = new FileReader();
      reader.onload = (data) => setImageData(data.target.result);
      reader.readAsDataURL(image);
    }
  }, [image, modal]);

  return (
    <div className={`modal ${modal ? 'is-active' : ''}`}>
      <div className='modal-background' onClick={() => setModal({ id: 0, name: null })}></div>
      <div className='modal-card'>
        <header className='modal-card-head'>
          <p className='modal-card-title'>صورة القسم {category.name}</p>
          <a className='delete' aria-label='close' onClick={() => setModal({ id: 0, name: null })}></a>
        </header>
        <div className='modal-card-body'>
          <div className='file is-boxed is-centered'>
            <label className='file-label'>
              <input className='file-input' type='file' name='theme' onChange={ _selectImage } />
              <span className='file-cta'>
                <span className='file-label'>
                  اختر الصورة
                </span>
              </span>
            </label>
          </div>
          <ShowImage />
        </div>
        <footer className='modal-card-foot'>
          <a type='button' className='button' data-bs-dismiss='modal' onClick={() => setModal({ id: 0, name: null })}>اغلاق</a>
          <button type='submit' className='button is-danger' onClick={ _submit } disabled={loading}>حفظ</button>
        </footer>
      </div>
    </div>
  )
}

export default CategoryImage;
